import { Outlet } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import CollectionsBootstrap from 'modules/tasks/lib/EmployeesCollectionsBootstrap'

const Container = () => {
  const {
    employee,
    access: { id: accessId },
  } = useCurrentSession()
  return (
    <Outlet
      context={{
        currentUserId: accessId,
        employee,
      }}
    />
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
